import type { ChannelMember } from '@src/api/shared/community/channelMemberApiClient';
import { createMentionPlugin } from '@src/ui/Editor/plugins/mentionPlugin';
import { Extension } from '@tiptap/core';

export const MentionSuggestion = Extension.create<{ members: ChannelMember[] }>({
  name: 'mentionSuggestion',

  addOptions() {
    return { members: [] };
  },

  addProseMirrorPlugins() {
    return [createMentionPlugin(this.options.members)];
  },
});
